//*******************************************************
import { Component,
         ViewChild }                    from '@angular/core';
//*******************************************************
// Router
import { Router, ActivatedRoute }       from '@angular/router';

import { Observable, Subscription }     from 'rxjs';
//*******************************************************
// Devexpress 
import { DxFormComponent }                from 'devextreme-angular';
import { DxDataGridComponent }            from 'devextreme-angular';
import { DxValidationGroupComponent }     from 'devextreme-angular/ui/validation-group';
//*******************************************************
// Firestore 
import { firestorecontrol }             from "../../appfirestore/app.firestore";
//*******************************************************
// Functions
import { appfunctions  }                from '../../functions/app.functions';
//*******************************************************
// Field Definitions
import { 
          giftList 
       }                                 from '../../appfirestore/app.fields';
//*******************************************************
@Component(
            {
              selector: 'app-cominviteegiftregister',
              templateUrl: './cominviteegiftregister.component.html',
              styleUrls: ['./cominviteegiftregister.component.scss']
            }
          )
//*******************************************************
export class CominviteegiftregisterComponent 
{
  //*******************************************************
  eventid: string = '';
  formheight: number = 0;
  //*******************************************************
  @ViewChild('grideventgift') dataGrid: DxDataGridComponent;

  @ViewChild('formgift') formgift: DxFormComponent;
  //*******************************************************
  // eventinvitee
  subscriptiongift: Subscription;
  subscriptiongiftlist: giftList[];

  // Firestore Paths
  pathgift: string = "/eventgiftlist/giftlist" 

  // Array of Data
  formData: Array<giftList> = [];
  newgift: any;
  statusvaluechange: boolean = false;

  // Button
  selButton: number;
  buttondisable: boolean = true;

  popuptitle: string = "";
  popupgiftVisible: boolean = false;

  // Row Selected
  rowdata: any;
  rowselect: boolean = false;
  focusedRowKey: number = 0;

  labelTemplates: any[];
  //*******************************************************
  constructor (
                private routernavigate: Router,
                private _Activatedroute:ActivatedRoute,
                private firestoredata: firestorecontrol, 
                private appfunction: appfunctions
              ) 
    {

      this.saveClick = this.saveClick.bind(this);
      this.cancelClick = this.cancelClick.bind( this);

      this.labelTemplates = [
        { name: 'name',       icon: 'dx-icon-user' },
        { name: 'position',   icon: 'dx-icon-info' },
        { name: 'date',       icon: 'dx-icon-event' },
        { name: 'address',    icon: 'dx-icon-home' },
        { name: 'phone',      icon: 'dx-icon-tel' },
        { name: 'email',      icon: 'dx-icon-email' },
        { name: 'mobile',     icon: 'fa-solid fa-mobile-retro' },
        { name: 'note',       icon: 'fa-regular fa-note-sticky'},
        { name: 'food',       icon: 'fa-solid fa-bowl-food'},
        { name: 'road',       icon: 'fa-sharp fa-solid fa-road'},
        { name: 'letter',     icon: 'fa-solid fa-square-envelope'},
        { name: 'address',    icon: 'fa-solid fa-address-card'}
      ];

    }
  //*******************************************************
  ngOnInit(): void 
    {
        // EventId
        this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
        // Form Height
        this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
        //---------------------------------------------------------------------------------------------
        // Establish Connection to event -> eventparticipant
        this.firestoredata.loadeventgiftlist( this.eventid );

        this.subscriptiongift = this.firestoredata.geteventgiftlist().subscribe
          ( items => 
            { 
              this.subscriptiongiftlist = items;
              //console.log( this.subscriptiongiftlist )
            }
          )
      //---------------------------------------------------------------------------------------------
    }
  //*******************************************************
  ngOnDestroy() 
    {
        console.log('destroy1')
       
    }
  //*******************************************************
  editorPreparing( event: any )
    {

        if (  event.rowType == "data" ) 
          {
            var $links = event.cellElement.find(".dx-link");
            $links.filter(".dx-link-delete").remove();

            if (   event.column.command =="edit" )
              {
                $links.filter(".dx-link-edit").remove();
              }

          }

      }
    //*******************************************************
    giftform( event: any, seloption: number)
       {
          var status: boolean

          this.selButton = seloption;
          //---------------------------------------------------------------------------------------------
          // Determine whether a ROW is selected when its not a ADD option
          if ( this.selButton  != 10 )
            {
              
              if ( this.rowselect ) 
                {
                  status             = true;
                }
              else
                {
                  status             = false; 
                }
            }
         else
           {
             console.log( 'add')
           }
          //---------------------------------------------------------------------------------------------
          switch ( seloption )
            {
              //---------------------------------------------------------------------------------------------
              // Add Gift
              case 10:
                  {
                    //---------------------------------------------------------------------------------------------
                    // Set Inputs to null values
                    this.formData = [];
                    // Set Default Values for a New Gift
                    this.newgift                  = this.formData
                    this.newgift.id               = this.appfunction.createuniqueid(4)
                    this.newgift.giftdescription  = '';
                    this.newgift.giftlist         = false;
                    this.newgift.brand            = '';
                    this.newgift.sourceoption     = '';
                    this.newgift.notes            = '';
                    // Set formData to default Value
                    this.formData                 =   this.newgift;
                    //---------------------------------------------------------------------------------------------
                    this.popuptitle           = 'Add Gift Profile';
                    this.popupgiftVisible     = true;
                    this.buttondisable        = true;
                    //---------------------------------------------------------------------------------------------

                    break;
                  }
              //---------------------------------------------------------------------------------------------
              // Edit Gift
              case 20:
                  {

                    if ( status )
                      {
                        this.popuptitle           = 'Edit Gift Profile';
                        this.popupgiftVisible     = true;
                      }

                    break;  
                  
    
                  }
              //---------------------------------------------------------------------------------------------

            }
          //---------------------------------------------------------------------------------------------
       }
    //*******************************************************
    // Save Gift Details
    saveClick()
      {

        // Validation for formData
        let validresult = this.formgift.instance.validate();
        
        if ( validresult.isValid  )
          {
     
            this.newgift =  this.formData
            console.log( this.newgift )
            //console.log( this.newgift.giftdescription )
            //---------------------------------------------------------------------------------------------
            // Save Data - Firestore
            this.firestoredata.AddUpdateGift( this.selButton, this.eventid, this.newgift  );
            //---------------------------------------------------------------------------------------------
             // Set Focus to the New Addded Row
             this.dataGrid.instance.clearSelection();
             this.dataGrid.instance.option("focusedRowKey",  -1 );

             // Focus Row when inserted
             setTimeout(() => {
                                 this.dataGrid.instance.option("focusedRowKey",  this.newgift.id  );
                               }, 100
                       );
            //---------------------------------------------------------------------------------------------
            this.buttondisable      = false;
            this.popupgiftVisible   = false;
            //---------------------------------------------------------------------------------------------  
          }

      }
    //*******************************************************
    cancelClick()
      {

        switch (  this.selButton )
          {
            //---------------------------------------------------------------------------------------------
            case 10:  // cancel-Add Gift Details
              {
                if ( this.subscriptiongiftlist.length == 0 )
                  {
                    this.buttondisable  = true;
                  }
                else
                  {

                    if ( this.rowselect )
                      {
                        // Focus
                        this.buttondisable  = false;

                        // Focus Row when cancel from Add Invitee
                        this.dataGrid.instance.clearSelection();
                        this.dataGrid.instance.option("focusedRowKey",  -1 );
                        setTimeout(() => {
                                        this.dataGrid.instance.option("focusedRowKey",  this.focusedRowKey  );
                                        }, 100
                                  );

                      }

                  }

                this.buttondisable = false;       // Disable Invitee form buttons
                this.popupgiftVisible = false;
                break;
              }
            //---------------------------------------------------------------------------------------------
            case 20:    // Disable-Gift Details
              {
                  // Trigger a refresh of the DataGrid when Cancel is selected
                  //---------------------------------------------------------------------------------------------
                  if ( this.statusvaluechange )
                    {
                      //---------------------------------------------------------------------------------------------
                      this.firestoredata.commitbatchupdate( 
                                                              this.pathgift, 
                                                              this.eventid,
                                                              this.focusedRowKey.toString(),
                                                              'triggerrefresh', 
                                                              this.appfunction.createuniqueid(3)
                                                          );  

                      //---------------------------------------------------------------------------------------------
                      // Focus Row when cancel
                      this.dataGrid.instance.clearSelection();
                      this.dataGrid.instance.option("focusedRowKey",  -1 );
                      setTimeout(() => {
                                      this.dataGrid.instance.option("focusedRowKey",  this.focusedRowKey  );
                                      }, 100
                                );
                      //---------------------------------------------------------------------------------------------
                    
                    }

                  this.buttondisable = false;       // Disable Invitee form buttons
                  this.popupgiftVisible = false;

                  break;
              }
            //---------------------------------------------------------------------------------------------
          }

      }
    //*******************************************************
    onrowclick( event: any )
      { 
      
        this.rowselect = true;            // Indicate that Datagrid - invitee has been selected
        this.buttondisable = false;       // Enable Invitee form buttons
        // Capture Select Row Data Id
        this.focusedRowKey = event.data.id;  // Register Data Row - id
        // Save data
        this.inviteedataprofile( 10, event ) // Store Data Row Data
    
      }
    //*******************************************************
    onrowchange( event: any )
        {
          this.rowselect = true;                        // Indicate that Datagrid - invitee has been selected
          
          this.buttondisable = true;                   // Enable Invitee form buttons
          
          // Capture Select Row Data Id
          this.focusedRowKey = event.row.data.id;       // Register Data Row - id
          // Save data
          this.inviteedataprofile( 20, event )          // Store Data Row Data

        }
    //*******************************************************
    formDatafldchange( event: any )
      {
        // Formdata has changed
        this.statusvaluechange = true;
      }
    //*******************************************************
    inviteedataprofile( settype: number,  seldata: any)
        {
          switch ( settype )
            {
              // Row Click
              case 10:
                {
                 
                  this.formData        = seldata.data;
                  this.rowdata         = seldata.data
                  break;

                }

              // Row Change
              case 20:
                {
                  this.formData        = seldata.row.data;
                  this.rowdata         = seldata.row.data
                  break; 
                }

            }

        }
    //*******************************************************
}
